<div class="perm-tree" role="tree" aria-label="Módulos, áreas e telas do menu">
  @if (!query()) {
    <!-- A Home não depende de permissão: aparece para todo usuário, como no protótipo. -->
    <div class="perm-tree__row perm-tree__row--fixed" role="treeitem" aria-disabled="true">
      <span class="perm-tree__chevron-spacer"></span>
      <i class="pi pi-lock perm-tree__lock" aria-hidden="true"></i>
      <span class="perm-tree__label">Home</span>
      <span class="perm-tree__fixed-note">sempre visível</span>
    </div>
  }
  @for (module of modules(); track module.id) {
    @if (module.isOther) {
      <div class="perm-tree__divider" role="separator"></div>
    }
    <ng-container
      *ngTemplateOutlet="row; context: { $implicit: module, level: 0, hasChildren: true }" />
    @if (isExpanded(module.id)) {
      <div role="group">
        @for (child of module.children; track child.id) {
          @if (child.kind === 'area') {
            <ng-container
              *ngTemplateOutlet="row; context: { $implicit: child, level: 1, hasChildren: true }" />
            @if (isExpanded(child.id)) {
              <div role="group">
                @for (screen of child.screens; track screen.id) {
                  <ng-container
                    *ngTemplateOutlet="
                      row;
                      context: { $implicit: screen, level: 2, hasChildren: false }
                    " />
                }
              </div>
            }
          } @else {
            <ng-container
              *ngTemplateOutlet="
                row;
                context: { $implicit: child, level: 1, hasChildren: false }
              " />
          }
        }
      </div>
    }
  }
</div>

<ng-template #row let-node let-level="level" let-hasChildren="hasChildren">
  @let nodeCount = count(node);
  @let nodeState = state(node);
  <div
    class="perm-tree__row"
    role="treeitem"
    tabindex="0"
    [attr.aria-level]="level + 1"
    [attr.aria-expanded]="hasChildren ? isExpanded(node.id) : null"
    [attr.aria-selected]="activeId() === node.id"
    [class.perm-tree__row--module]="level === 0"
    [class.perm-tree__row--area]="level === 1 && hasChildren"
    [class.perm-tree__row--active]="activeId() === node.id"
    [style.padding-left.px]="12 + level * 18"
    (click)="onRowClick(node)"
    (keydown.enter)="onRowClick(node)"
    (keydown.space)="$event.preventDefault(); onRowClick(node)"
    (keydown)="onRowKeydown($event, node, hasChildren)">
    @if (hasChildren) {
      <button
        type="button"
        class="perm-tree__chevron"
        [attr.aria-label]="(isExpanded(node.id) ? 'Recolher ' : 'Abrir ') + node.label"
        (click)="onChevronClick($event, node.id)">
        <i
          class="pi"
          [class.pi-chevron-down]="isExpanded(node.id)"
          [class.pi-chevron-right]="!isExpanded(node.id)"></i>
      </button>
    } @else {
      <span class="perm-tree__chevron-spacer"></span>
    }

    <button
      type="button"
      role="checkbox"
      class="perm-tree__check"
      [class.perm-tree__check--on]="nodeState === 'on'"
      [class.perm-tree__check--partial]="nodeState === 'partial'"
      [attr.aria-checked]="ariaChecked(node)"
      [attr.aria-label]="
        (nodeState === 'on' ? 'Desmarcar tudo em ' : 'Marcar tudo em ') + node.label
      "
      (click)="onCheckClick($event, node)">
      @if (nodeState === 'on') {
        <i class="pi pi-check"></i>
      } @else if (nodeState === 'partial') {
        <i class="pi pi-minus"></i>
      }
    </button>

    <span class="perm-tree__label">
      @for (part of segments(node.label); track $index) {
        <span [class.perm-tree__mark]="part.match">{{ part.text }}</span>
      }
    </span>
    @if (isChanged(node)) {
      <span
        class="perm-tree__dot"
        title="Tem alteração não salva"
        aria-label="Tem alteração não salva"></span>
    }
    @if (query()) {
      <!-- Na busca a base é outra (só os resultados): mostra quantos resultados, não "marcadas/total". -->
      <span
        class="perm-tree__count perm-tree__count--results"
        [title]="nodeCount.total + (nodeCount.total === 1 ? ' resultado' : ' resultados')">
        {{ nodeCount.total }}
      </span>
    } @else {
      <span class="perm-tree__count" [class.perm-tree__count--some]="nodeCount.selected > 0">
        {{ nodeCount.selected }}/{{ nodeCount.total }}
      </span>
    }
  </div>
</ng-template>
